// src/components/PracticeAreaPicker.js
import React, { useState, useMemo } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  List,
  ListItemButton,
  TextField,
  InputAdornment,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import PropTypes from "prop-types";
import { flatPracticeAreaDict } from "../../../helpers/stringHelper";

export default function PracticeAreaPicker({ open, onClose, onSelect }) {
  const [search, setSearch] = useState("");

  // Turn dict → [{ slug, label }]
  const choices = useMemo(
    () =>
      Object.entries(flatPracticeAreaDict).map(([slug, label]) => ({
        slug,
        label,
      })),
    []
  );

  const filtered = useMemo(() => {
    if (!search.trim()) return choices;
    const s = search.toLowerCase();
    return choices.filter(
      (c) => c.label.toLowerCase().includes(s) || c.slug.includes(s)
    );
  }, [choices, search]);

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Select a practice area</DialogTitle>
      <DialogContent dividers>
        <TextField
          variant="outlined"
          fullWidth
          placeholder="Search…"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
          sx={{ mb: 2 }}
        />

        <List sx={{ maxHeight: 400, overflowY: "auto", p: 0 }}>
          {filtered.map(({ slug, label }) => (
            <ListItemButton
              key={slug}
              onClick={() => {
                onSelect({ slug, label });
                onClose();
              }}
            >
              {label}
            </ListItemButton>
          ))}
          {filtered.length === 0 && (
            <em style={{ padding: "0 16px" }}>No matches…</em>
          )}
        </List>
      </DialogContent>
    </Dialog>
  );
}

PracticeAreaPicker.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
};
